export default "__VITE_ASSET__a10f5d10__"